import {
  Calendar,
  Car,
  Languages,
  MapPin,
  Search,
} from "lucide-react";

function FilterDashboard() {
  return (
    <div className="relative w-full my-8 overflow-hidden rounded-lg">
      <div className="relative w-full h-[540px]">
        <img
          src="/images/travelassist.png"
          alt="Google"
          className="w-full h-full object-cover block"
        />

        {/* Responsive Overlay */}
        <div className="absolute inset-x-4 bottom-4 flex flex-wrap md:flex-nowrap gap-4 md:gap-2 p-3 bg-white/80 rounded-lg items-start md:items-center justify-between">
          {/* Location */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%]">
            <p className="text-sm font-medium">Location</p>
            <span className="bg-white flex gap-2 text-gray-500 rounded p-2 items-center">
              <MapPin size={16} />
              <input
                className="outline-none w-full text-sm"
                type="text"
                placeholder="Enter your location"
              />
            </span>
          </div>

          {/* Date */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%]">
            <p className="text-sm font-medium">Date</p>
            <span className="bg-white flex gap-2 text-gray-500 rounded p-2 items-center">
              <Calendar size={16} />
              <input
                className="outline-none w-full text-sm appearance-none"
                type="date"
              />
            </span>
          </div>

          {/* Language */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%]">
            <p className="text-sm font-medium">Language</p>
            <span className="bg-white flex gap-2 text-gray-500 rounded p-2 items-center">
              <Languages size={16} />
              <input
                className="outline-none w-full text-sm"
                type="text"
                placeholder="Enter language"
              />
            </span>
          </div>

          {/* Keyword */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%]">
            <p className="text-sm font-medium">Keyword</p>
            <span className="bg-white flex gap-2 text-gray-500 rounded p-2 items-center">
              <Car size={16} />
              <input
                className="outline-none w-full text-sm"
                type="text"
                placeholder="Search"
              />
            </span>
          </div>

          {/* Car Option */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%]">
            <p className="text-sm font-medium">Car Option</p>
            <span className="bg-white flex gap-2 text-gray-500 rounded p-2 items-center justify-center">
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-[#570033] transition-all"></div>
                <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transform peer-checked:translate-x-full transition-all"></div>
              </label>
            </span>
          </div>

          {/* Search Button */}
          <div className="flex flex-col gap-2 w-full md:w-1/2 lg:w-[16%] mt-2 md:mt-0">
            <p className="invisible  text-sm font-medium">Search</p>
            <button className="w-full bg-[#570033] text-white p-2 rounded flex items-center justify-center gap-2">
              Search <Search size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterDashboard;